import { catchErrorSync } from '~/utils/catch-error'

export const COOKIE_SCRIPT_KEY = 'CookieScriptConsent' as const

let listenersAdded = false

const setCookieScriptListener = () => {
  if (import.meta.client && !listenersAdded) {
    listenersAdded = true
    const handleConsentChange = () => refreshCookie(COOKIE_SCRIPT_KEY)

    window.addEventListener('CookieScriptAccept', handleConsentChange)
    window.addEventListener('CookieScriptAcceptAll', handleConsentChange)
    window.addEventListener('CookieScriptReject', handleConsentChange)
  }
}

const getCategoryConsent = (category: string) => {
  const cookie = useCookie<any>(COOKIE_SCRIPT_KEY)

  return computed(() => {
    if (!cookie.value?.categories) return false

    const [categories] = catchErrorSync(
      () =>
        import.meta.client &&
        window?.CookieScript?.instance.currentState().categories,
    )

    return Array.isArray(categories) && categories.includes(category)
  })
}

type TParams = {
  category: string
  onChange?: (accepted: boolean) => void
}

export const getCookieConsentByCategory = ({ category, onChange }: TParams) => {
  setCookieScriptListener()

  const consent = getCategoryConsent(category)

  if (onChange) {
    watch(consent, onChange, { immediate: true })
  }

  return consent
}
